import * as React from 'react';
export const InjectReducerContext = React.createContext({
    injectAsyncReducer: () => undefined,
});
